import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GetEmailDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../translations';
import { useNotifications } from '../../../common/hooks/useNotifications';

import { EmailHistoryModal } from './EmailHistoryModal';

export const EmailHistoryLink = (props: { emailId: string }) => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('applicationLng');
  const [showHistory, setShowHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emails, setEmails] = useState<GetEmailDto[]>([]);

  const handleClick = async () => {
    setLoading(true);
    try {
      const history = await pok.emails.getHistory(props.emailId);
      setEmails(history);
      setShowHistory(true);
    } catch (error) {
      notifications.caughtError(error as ResponseError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="link"
        className="ms-1"
        onClick={handleClick}
        disabled={loading}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {t(tk.email.historyTooltip)}
            </Tooltip>
          }
        >
          <Icon.ClockHistory size={18} />
        </OverlayTrigger>
      </Button>
      {showHistory && (
        <EmailHistoryModal
          show={showHistory}
          onHide={() => setShowHistory(false)}
          emails={emails}
          currentEmailId={props.emailId}
        />
      )}
    </>
  );
};
